import React from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../../components";

const UploadLcaModal = ({ isOpen, onClose }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      uploadFile: [],
    },
    {
      uploadFile: {
        type: "file",
        required: true,
        // allowedFiles: [{ ext: "txt", mime: "text/plain" }],
      },
    }
  );

  const handleUpload = async() => {
    try {
      const isValid = validateAllFields();
      if (isValid) {
        // onClose();
        const result = await parsePdfToJson(formData.uploadFile[0]);
        console.log("result of parse",result);
        // onAccept();
      }
    } catch (error) {
      console.error("result of parse error",error);
      
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="max-w-2xl"
      title={"Upload File"}
      showCloseButton={true}
    >
      <div className="p-4 flex flex-col">
        <div className="flex flex-col items-center flex-2">
          <FormFieldSet
            title="Paper LCA"
            type="file"
            placeholder="Choose file"
            value={formData.uploadFile}
            onChange={(val) => handleChange("uploadFile", val)}
            error={errors.uploadFile}
          />
        </div>
        <div className="flex justify-end mt-10">
          <Button
            title="Upload"
            variant="outlined"
            onClick={() => handleUpload()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default UploadLcaModal;
